import React from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';

import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import SeoIndexAlphabetNav from '../../components/SeoDiscovery/SeoIndexAlphabetNav';
import SeoIndexPagination from '../../components/SeoDiscovery/SeoIndexPagination';
import { propTypes } from '../../util/types';
import css from '../../components/SeoDiscovery/SeoDiscovery.module.css';
import {
  PERFORMER_INDEX_PAGE_SIZE,
  performersIndexPath,
  performersLetterPath,
} from '../../util/seoDiscoveryIndexLetters';

const letterTitle = letter => (letter === '#' ? '0–9' : letter);

export const SeoDiscoveryPerformersLetterPageComponent = props => {
  const { data, fetchInProgress, fetchError } = props;
  const performers = data?.performers || [];
  const letter = data?.letter || 'A';
  const letterCounts = data?.letterCounts || {};
  const total = data?.total || 0;
  const page = data?.page || 1;
  const letterLabel = letterTitle(letter);

  return (
    <Page
      title={`Performers starting with ${letterLabel} | PromoTix`}
      description={`Browse performers starting with ${letterLabel}. Find upcoming events, tickets, and tour dates.`}
      schema={{
        '@context': 'https://schema.org',
        '@type': 'CollectionPage',
        name: `PromoTix Performers — ${letterLabel}`,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <p className={css.indexBreadcrumb}>
            <a href={performersIndexPath()}>Performers</a>
            {' / '}
            {letterLabel}
          </p>
          <h1 className={css.h1}>Performers — {letterLabel}</h1>
          <p>Discover artists and shows starting with {letterLabel}.</p>
          {fetchError ? <p>Unable to load performers.</p> : null}
          {fetchInProgress && !performers.length ? <p>Loading…</p> : null}
          <SeoIndexAlphabetNav
            activeLetter={letter}
            letterCounts={letterCounts}
            getLetterHref={performersLetterPath}
          />
          <section className={css.letterSection}>
            <h2 className={css.letterHeading}>{letterLabel}</h2>
            <ul className={css.indexList}>
              {performers.map(p => (
                <li key={p.slug || p.performerId}>
                  <a href={p.path}>{p.performerName}</a>
                  <span className={css.eventMeta}>
                    {' '}
                    — {p.eventCount || 0} event{(p.eventCount || 0) === 1 ? '' : 's'}
                  </span>
                </li>
              ))}
            </ul>
          </section>
          <SeoIndexPagination
            currentPage={page}
            pageSize={PERFORMER_INDEX_PAGE_SIZE}
            total={total}
            getPageHref={nextPage => performersLetterPath(letter, nextPage)}
          />
          <p>
            <a href={performersIndexPath()}>Back to all performer letters</a>
          </p>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

SeoDiscoveryPerformersLetterPageComponent.propTypes = {
  data: object,
  fetchInProgress: bool,
  fetchError: propTypes.error,
};

const mapStateToProps = state => state.SeoDiscoveryPerformersLetterPage || {};

export default connect(mapStateToProps)(SeoDiscoveryPerformersLetterPageComponent);
